import React, { useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import WatchlistAdd from '@mui/icons-material/PlaylistAdd';
import AddToWatchlistModal from './add_to_watchlist_modal.js';

export const headerActionButtonSx = {
  width: 28,
  height: 28,
  borderRadius: '8px',
  border: '1px solid rgba(255,255,255,0.14)',
  backgroundColor: 'rgba(255,255,255,0.04)',
  color: '#FFFFFF',
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.08)',
  transition: 'all 0.18s ease',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.1)',
    borderColor: 'rgba(255,255,255,0.32)',
  },
  '&:focus-visible': {
    outline: 'none',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.08)',
  },
  '&.Mui-disabled': {
    opacity: 0.35,
    color: '#FFFFFF',
  },
};

const AddToWatchlistButton = ({ instrument, instrumentName, sx, iconSize = 18 }) => {
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    if (!instrument) {
      return;
    }
    setShowModal(true);
  };

  return (
    <>
      {showModal ? (
        <AddToWatchlistModal
          open={true}
          onClose={() => setShowModal(false)}
          instrument={instrument}
          instrumentName={instrumentName ?? instrument}
        />
      ) : null}
      <Tooltip title="Add to watchlist">
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', flexShrink: 0 }}>
          <IconButton
            size="small"
            disabled={!instrument}
            onClick={handleClick}
            sx={{ ...headerActionButtonSx, flexShrink: 0, ...sx }}
          >
            <WatchlistAdd sx={{ width: iconSize, height: iconSize }} />
          </IconButton>
        </Box>
      </Tooltip>
    </>
  );
};

export default AddToWatchlistButton;
